export const getMacUsage=(currentJob)=>{
     var containerId =  currentJob && currentJob.treatmentTypeDetails&& currentJob.treatmentTypeDetails.sizeOfContainerId ?currentJob.treatmentTypeDetails.sizeOfContainerId:null
    var displayName  = '20\' Standard'
    var numOfContainers =  currentJob && currentJob.treatmentTypeDetails&&currentJob.treatmentTypeDetails.numberOfContainers?currentJob.treatmentTypeDetails&&currentJob.treatmentTypeDetails.numberOfContainers:1;
    var qty = '99'

    var arophalus = isArhoPhalus(currentJob.treatmentDetails.standardId)
        console.log('getMacUsed',currentJob,numOfContainers)
    if(containerId == 'c3e46cf0-0ed1-4889-8063-8be30b7c3d34'){
    displayName = '20\' Standard'
    qty = 61;
    }
    if(containerId == '43e3f0a4-003f-431a-801c-e94d55c124a9'){
        displayName = '40\' High Cube'
        qty = 133
    }
    if(containerId == 'ca8be342-067f-446e-8cee-5491c9df0c07'){
        displayName = '40\' Standard'
        qty = 115
    }
    if(containerId == 'fa04ecbf-21a8-40d6-987b-4d8f202ad67e'){
        displayName = '20\' High Cube'
        qty = 70
    }
    if(containerId == 'f964eb9f-7c30-48b3-9db9-ef5fe277cf3b'){
        displayName = '20\' Reefer'
        qty = 61
    }
    if(containerId == '5374013f-1dd3-45db-ad99-9c42d74b2a2e'){
        displayName = '40\' Reefer'
        qty = 115
    }
    if(containerId == '12fe2dba-8ef2-4de4-a418-f0a2f0b664a3'){
        displayName = '20\''
        qty = 133
    }
    if(containerId == '20026375-61a8-425f-ab60-956752b590f59'){
        displayName = '40\''
        qty = 115
    }
    if(containerId == 'fa04ecbf-21a8-40d6-987b-4d8f202ad67e' && arophalus ){ //20 high
         qty = 61

    }
     if(containerId == '43e3f0a4-003f-431a-801c-e94d55c124a9' && arophalus ){ //40 high
         qty = 133

    }
    if(containerId == '20026375-61a8-425f-ab60-956752b590f59' && arophalus){ //40 std
        displayName = '40\'' 
        qty = 115
    }
     if(containerId == 'c3e46cf0-0ed1-4889-8063-8be30b7c3d34' && arophalus ){  //20 std
    displayName = '20\' Standard'
    qty = 61;
    } 

    return (qty * numOfContainers)+''

}

 export function isArhoPhalus(standardId){
    var isArhoPhalus = false;    
    if(standardId== 'a1fbd66f-e4dd-4b99-8f35-04ab19908cd6'){
isArhoPhalus = true;
    }

    return  isArhoPhalus;
}